export default function Comparison() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-3">
            Feature Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Vigorbuy Spreadsheet vs Traditional Search
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            See how organized spreadsheet research compares to traditional product searching methods.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                <th className="text-center px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1.5">
                    <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                    Vigorbuy Spreadsheet
                  </span>
                </th>
                <th className="text-center px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">
                  <span className="inline-flex items-center gap-1.5">
                    <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
                    Traditional Search
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Organized Product Lists', vigorbuy: true, traditional: false },
                { feature: 'Category Navigation', vigorbuy: true, traditional: 'Limited' },
                { feature: 'Side-by-Side Comparison', vigorbuy: true, traditional: false },
                { feature: 'Beginner Friendly Guides', vigorbuy: true, traditional: 'Limited' },
                { feature: 'Product Research Speed', vigorbuy: 'Faster', traditional: 'Slower' },
                { feature: 'Structured Data Format', vigorbuy: true, traditional: false },
                { feature: 'Cross-Category Browsing', vigorbuy: true, traditional: 'Manual' },
                { feature: 'Safety Information', vigorbuy: true, traditional: 'Scattered' },
              ].map((row, i) => (
                <tr key={row.feature} className={`border-t border-background-200/50 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                  <td className="px-5 py-3.5 font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-3.5 text-center">
                    {row.vigorbuy === true ? (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-accent-100">
                        <i className="ri-check-line text-accent-600 text-sm"></i>
                      </span>
                    ) : (
                      <span className="font-semibold text-accent-600">{row.vigorbuy}</span>
                    )}
                  </td>
                  <td className="px-5 py-3.5 text-center">
                    {row.traditional === false ? (
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-secondary-100">
                        <i className="ri-close-line text-secondary-500 text-sm"></i>
                      </span>
                    ) : (
                      <span className="text-secondary-600">{row.traditional}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}